/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class PayrollDetailsEditor extends _Ext.GridEditorBase<PayrollDetailsRow> {
        protected getColumnsKey() { return "HR.PayrollDetails"; }
        protected getDialogType() { return PayrollDetailsDialog; }
        protected getLocalTextPrefix() { return PayrollDetailsRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        }
        public getColumns() {

            var columns = super.getColumns();

            //columns.unshift({
            //    field: 'Delete Row',
            //    name: '',
            //    format: ctx => '<a class="inline-action delete-row" title="delete">' +
            //        '<i class="fa fa-trash-o text-red"></i></a>',
            //    width: 24,
            //    minWidth: 24,
            //    maxWidth: 24
            //});

            return columns;
        }


        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var id = this.id(item);
            var target = $(e.target);


            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Delete record?', () => {

                        this.view.deleteItem(id);
                        this.view.refresh();
                    });
                }
                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");

            buttons.push({
                title: 'Get All Employees',
                cssClass: '',
                onClick: () => {
                    var companyid = parseInt((this.parentDialog as PayrollDialog).form.BranchId.value);
                    var departmentid = parseInt((this.parentDialog as PayrollDialog).form.DepartmentId.value);
                    var designationid = parseInt((this.parentDialog as PayrollDialog).form.DesignationId.value);
                    PayrollDetailsService.GetEmployeePayroll({
                        CompanyId: companyid, DepartmentId: departmentid, DesignationId: designationid
                    },
                        response => {
                            if (response.Entities != null && response.Entities.length > 0) {
                                for (var i = 0; i < response.Entities.length; i++) {
                                    response.Entities[i][this.getIdProperty()] = "`" + this.nextId++;

                                    this.view.addItem(response.Entities[i])
                                }
                            }
                        }, { async: false })
                }
            })
            return buttons;
        }

    }
}